import React from "react";
import { Link } from "react-router-dom";

/** Home page block: a heading above a white panel, with an optional bar for a subtitle and a link. */
const HomeSection = ({ title, subtitle, action, children, className = "" }) => (
  <section className={`home-block ${className}`}>
    {title && <h2 className="home-block__title">{title}</h2>}
    <div className="home-block__panel">
      {(subtitle || action) && (
        <div className="home-block__bar">
          {subtitle && <span className="home-block__subtitle">{subtitle}</span>}
          {action && (
            <Link
              to={action.to}
              className="home-block__action btn btn-outline-main text-uppercase fw-semibold"
            >
              {action.label}
            </Link>
          )}
        </div>
      )}
      <div className="home-block__body">{children}</div>
    </div>
  </section>
);

export default HomeSection;
